import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class StandingsService {
  constructor(private apiService: ApiService) {}

  getAll(includeTemporaryPichichi = false, includeJokers = true) {
    return this.getStandings(
      '/standings',
      includeTemporaryPichichi,
      includeJokers,
    );
  }

  getSummary(includeTemporaryPichichi = false, includeJokers = true) {
    return this.getStandings(
      '/standings/summary',
      includeTemporaryPichichi,
      includeJokers,
    );
  }

  private getStandings(
    path: string,
    includeTemporaryPichichi = false,
    includeJokers = true,
  ) {
    const params = new URLSearchParams();
    if (includeTemporaryPichichi) {
      params.set('includeTemporaryPichichi', 'true');
    }
    if (!includeJokers) {
      params.set('includeJokers', 'false');
    }
    const query = params.toString();
    return this.apiService.request(
      `${path}${query ? `?${query}` : ''}`,
      'GET',
    );
  }

  getEvolution(groupId?: string) {
    const query = groupId ? `?groupId=${encodeURIComponent(groupId)}` : '';
    return this.apiService.request(`/standings/evolution${query}`, 'GET');
  }

  getSnipers(groupId?: string, roundId?: string) {
    const params = new URLSearchParams();

    if (groupId) {
      params.set('groupId', groupId);
    }

    if (roundId) {
      params.set('roundId', roundId);
    }

    const query = params.toString();
    return this.apiService.request(
      `/standings/snipers${query ? `?${query}` : ''}`,
      'GET',
    );
  }

  getScorers(limit = 50) {
    return this.apiService.request(`/stats/scorers?limit=${limit}`, 'GET');
  }

  getWorldCupGroupStandings() {
    return this.apiService.request('/stats/group-standings', 'GET');
  }

  getUser(userId: string) {
    return this.apiService.request(`/standings/user/${userId}`, 'GET');
  }

  getGroup(userId: string) {
    return this.apiService.request(`/standings/group/${userId}`, 'GET');
  }
}
